module.exports = __webpack_public_path__ + "img/box_1.29501969.png";